export default "__VITE_ASSET__41c5ad39__"